import React from "react";
import styled from "styled-components";
import Icon from "../components/atoms/Icon";

const ToastContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #52c41a; // 연두색
`;

const TextContent = styled.div`
  flex: 1;
  font-weight: 500;
  color: #262626;
`;

interface CompletionToastProps {
  patientId?: number;
  reviewId: number;
}

export const CompletionToast: React.FC<CompletionToastProps> = ({ patientId, reviewId }) => {
  const message = patientId
    ? `환자 #${patientId}의 보고서 #${reviewId} 분석이 완료되었습니다.`
    : `보고서 #${reviewId} 분석이 완료되었습니다.`;

  return (
    <ToastContainer>
      <IconWrapper>
        <Icon name="Check Circle Filled" size={24} />
      </IconWrapper>
      <TextContent>{FAILURE_TOAST_MESSAGE}</TextContent>
    </ToastContainer>
  );
};

interface FailureToastProps {
  patientId?: number;
  reviewId: number;
}

/**
 * 실패 토스트 문구 (spec 2026-08-31-phai-웹-LLM실패-사용자안내 · 화면 설계 7).
 * 사유는 보고서 화면의 실패 카드가 설명하므로 토스트는 사유 무관 단일 문구이며, 내부 ID를 노출하지 않는다.
 */
const FAILURE_TOAST_MESSAGE = "AI 분석이 실패했어요. 보고서 화면에서 확인해 주세요.";

export const FailureToast: React.FC<FailureToastProps> = () => {
  return (
    <ToastContainer>
      <IconWrapper style={{ color: '#ff4d4f' }}>
        <Icon name="X" size={24} />
      </IconWrapper>
      <TextContent>{FAILURE_TOAST_MESSAGE}</TextContent>
    </ToastContainer>
  );
};